import { DetachableElement } from '@99designs/frontend-components/components/DetachableElement';
import { FixedViewportElement } from '@99designs/frontend-components/components/FixedViewportElement';
import React from 'react';

interface Props {
    isAnimating?: boolean;
    children: React.ReactNode;
}

export function DetachedOverlay({ isAnimating, children }: Props) {
    return (
        <>
            {/* We don't want to wrap our component with this because React will force a rerender if we
        remove it */}
            {!isAnimating && <FixedViewportElement>{null}</FixedViewportElement>}
            <DetachableElement>
                <div className="detached-overlay">
                    <div className="detached-overlay__content">{children}</div>
                </div>
            </DetachableElement>
        </>
    );
}
